
import { useVodPageStore } from "@/stores/VodPage";
import { type RouteLocationNormalized } from 'vue-router';

const VodPageStore = useVodPageStore();
const {
	setShowAllSubGenres
} = VodPageStore;

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if (import.meta.client) {
		setShowAllSubGenres(Number(to.query.subGenreId));
	}
});